const initialState = window.init_data;
const initList = (initialState && initialState[1] && initialState[1].list) || [];
export default function ads(state = initList, action) {
  return state;
}